// D:\my-website\src\components\HomePage.js

import React from 'react';
import { Link } from 'react-router-dom'; // 导入 Link 组件
import { useTranslation } from 'react-i18next'; // 导入国际化钩子

// HomePage 组件现在只接收 homepageData prop
function HomePage({ homepageData }) {
  const { t } = useTranslation();

  // 确保 homepageData 存在，否则使用空对象或默认值
  const data = homepageData || {};

  return (
    <section id="home" className="relative h-screen flex items-center justify-center text-center text-white"
      style={{
        backgroundImage: `url(${data.heroBackgroundImageUrl || 'https://placehold.co/1920x1080/007bff/ffffff?text=Background+Image'})`, // 默认背景图
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed' // 固定背景，实现视差滚动效果
      }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div> {/* 半透明遮罩 */}
      <div className="relative z-10 p-8 max-w-4xl mx-auto bg-black bg-opacity-40 rounded-lg shadow-xl">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-4 leading-tight">
          {data.heroTitle || t('company_name')} {/* 使用公司名称作为默认标题 */}
        </h1>
        <p className="text-lg md:text-xl mb-8">
          {data.heroDescription || t('welcome_message')} {/* 使用欢迎信息作为默认描述 */}
        </p>
        {data.heroButtonText && (
          // 使用 Link 组件进行导航，不再使用 setCurrentPage
          <Link
            to="/about" // 假设“了解更多”按钮导航到“关于我们”页面
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full text-xl transition duration-300 ease-in-out transform hover:scale-105 shadow-lg"
          >
            {data.heroButtonText || t('button_learn_more')}
          </Link>
        )}
      </div>
    </section>
  );
}

export default HomePage;
